<template>
  <div class="mb-5">
    <div class="text-start mb-2">
      <v-btn
        class="blue white--text mx-1"
        :disabled="isMainLoading || settingTaskSelector.length <=0 || !enableSendApproveBillingSetting"
        @click="isSendSettingTask = true;currentNote = ''"
      >
        <template>{{ $t('appeal.send_appeal') }} {{`${settingTaskSelector.length ? settingTaskSelector.length + ` ${$t('list')}` : ''}`}}</template>
      </v-btn>
      <v-btn
        color="error"
        :disabled="isMainLoading || settingTaskSelector.length <=0"
        @click="isRemoveSettingTask = true"
      >
        <template>{{ $t('action_type.delete') }} {{ `${settingTaskSelector.length ? settingTaskSelector.length + ` ${$t('list')}` : ''}`}}</template>
      </v-btn>
    </div>
    <v-card flat outlined :loading="isMainLoading" min-height="30">
      <v-data-table
        :loading="isLoading"
        :items-per-page="10"
        :headers="settingTaskHeaders"
        :items="getSettingTasks"
        :no-data-text="$t('task.no_send_approve_setting')"
        class="elevation-0 outlined"
        sort-by="createdAt"
        :sort-desc="true"
        item-key="objectId"
        :show-select="true"
        v-model="settingTaskSelector"
        :no-results-text="$t('no_matching_records_found')"
      >
        <template v-slot:item.name="{ item }">{{item.area.name}}</template>
        <template v-slot:item.action="{ item }">{{item.actionString}} ({{item.typeName}})</template>
        <template v-slot:item.previousPrice="{ item }">
          <div class="text-end text-no-wrap">
            {{item.previousPrice | currencyPrefixSign(item.currencyCode)}}
          </div>
        </template>
        <template v-slot:item.currentPrice="{ item }">
          <div class="text-end text-no-wrap">
            {{item.currentPrice | currencyPrefixSign(item.currencyCode)}}
          </div>
        </template>
        <template v-slot:item.previousOriginalDiscount="{ item }">
          <div class="text-end text-no-wrap">
            {{item.previousOriginalDiscount | currencyPrefixSign(item.currencyCode)}}
          </div>
        </template>
        <template v-slot:item.currentOriginalDiscount="{ item }">
          <div class="text-end text-no-wrap">
            {{item.currentOriginalDiscount | currencyPrefixSign(item.currencyCode)}}
          </div>
        </template>
        <template v-slot:item.diffPrice="{ item }">
          <div class="text-end text-no-wrap d-inline-block" :class="item.diffPrice.class">
            {{item.diffPrice.text | currencyPrefixSign(item.currencyCode,{ mathType: "outSide" })}} 
          </div>
        </template>

        <template v-slot:item.createdBy="{ item }">{{item.createdByFullName}}</template>
        <template v-slot:item.createdAt="{ item }">{{item.createdAtDateFormat}}</template>
        <template v-slot:item.updatedBy="{ item }">{{item.updatedByFullName}}</template>
        <template
          v-slot:item.updatedAt="{ item }"
        >{{item.updatedBy ? item.updatedAtDateFormat : '-'}}</template>
        <template v-slot:item.status="{ item }">{{item.statusString}}</template>
      </v-data-table>
    </v-card>

    <confirm-dialog
      v-model="isRemoveSettingTask"
      v-if="settingTaskSelector && settingTaskSelector.length"
      :title="$t('task.you_want_to_delete_approve_setting', { count: settingTaskSelector.length })"
      :disabled="isLoading"
      @onOk="saveSettingTask('rejected')"
    ></confirm-dialog>

    <LoadingPercentDialog
      v-model="isLoadingDialog"
      :final="loadingFinal"
      :initial="loadingInitial"
    />
    <v-dialog v-model="isSendSettingTask" persistent max-width="600px">
      <v-card v-if="settingTaskSelector && settingTaskSelector.length">
        <v-card-title
          class="primary--text"
        >{{ $t('task.you_want_to_send_approve_setting', { count: settingTaskSelector.length}) }}</v-card-title>
        <v-card-text class="py-5">
          <p class="mb-3">
            <b>{{ $t('note_if_have') }}</b>
          </p>
          <v-textarea
            v-model="currentNote"
            :placeholder="$t('note_if_have_placeholder')"
            :label="$t('note')"
            class="mb-2"
            outlined
            dense
            hide-details
            rows="2"
            no-resize
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-btn @click="isSendSettingTask = false" :disabled="isLoading">
            <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
          </v-btn>
          <v-btn color="success" @click="saveSettingTask('pending')" :loading="isLoading">
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import ConfirmDialog from "./ConfirmDialog.vue";
import LoadingPercentDialog from "./LoadingPercentDialog.component";
import { Market, MarketSetting } from "../classes";
export default {
  components: {
    ConfirmDialog,
    LoadingPercentDialog
  },
  props: {
    isMainLoading: Boolean,
    marketId: String
  },
  computed: {
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    },
    ...mapGetters({
      getSettingTasks: "settingTask/getSettingTasks"
    }),
    enableEditBillingSetting() {
      let res = false;
      if (
        this.admin ||
        (this.employee && this.employee.enableEditBillingSetting)
      ) {
        res = true;
      }
      return res;
    },
    enableSendApproveBillingSetting() {
      let res = false;
      if (
        this.admin ||
        (this.employee && this.employee.enableSendApproveBillingSetting)
      ) {
        res = true;
      }
      return res;
    }
  },
  data() {
    return {
      settingTaskHeaders: [],
      currentNote: "",
      settingTaskSelector: [],
      isSendSettingTask: false,
      isRemoveSettingTask: false,
      isLoadingDialog: false,
      loadingInitial: 0,
      loadingFinal: 0,
      isLoading: false
    };
  },
  created() {
    this.settingTaskHeaders = [
      {
        align: "center",
        value: "name",
        text: this.$t('area.area_name')
      },
      {
        align: "center",
        value: "action",
        text: this.$t('market.action'),
        width: "180px"
      },
      {
        align: "center",
        value: "previousAccountingProduct",
        text: this.$t('payment.original_list')
      },
      {
        align: "center",
        value: "currentAccountingProduct",
        text: this.$t('payment.new_list')
      },
      {
        align: "center",
        value: "previousPrice",
        text: this.$t('payment.original_price')
      },
      {
        align: "center",
        value: "currentPrice",
        text: this.$t('payment.new_price')
      },
      {
        align: "center",
        value: "previousOriginalDiscount",
        text: this.$t('payment.original_discount')
      },
      {
        align: "center",
        value: "currentOriginalDiscount",
        text: this.$t('payment.new_discount')
      },
      {
        align: "right",
        value: "diffPrice",
        text: ""
      },
      {
        align: "center",
        value: "previousType",
        text: this.$t('payment.original_method')
      },
      {
        align: "center",
        value: "currentType",
        text: this.$t('payment.new_method')
      },
      {
        align: "center",
        value: "createdBy",
        text: this.$t('created_by')
      },
      {
        align: "center",
        value: "createdAt",
        text: this.$t('created_at')
      },
      {
        align: "center",
        value: "updatedBy",
        text: this.$t('change_status_by')
      },
      {
        align: "center",
        value: "updatedAt",
        text: this.$t('change_status_at')
      },
      {
        align: "center",
        value: "status",
        text: this.$t('status')
      }
    ];
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.$emit("onInitSettingTask");
    },
    async saveSettingTask(status = "rejected") {
      this.isLoading = true;
      this.isLoadingDialog = true;
      this.loadingFinal = 0;
      this.loadingInitial = 1;
      if (this.settingTaskSelector && this.settingTaskSelector.length) {
        let forms = [];
        for (const settingTask of this.settingTaskSelector) {
          let form = Object.assign({}, settingTask);
          if (this.currentNote) {
            form.description = this.currentNote;
          }
          form.status = status;
          forms.push(form);
        }

        let hashCurrency = {};
        if(forms.length > 0){
          for(const form of forms){
            if(!form.currencyCode){
              form.currencyCode = this.$globalCurrencyCode;
            }
            if(!hashCurrency[form.currencyCode]){
              hashCurrency[form.currencyCode] = [];
            }
            hashCurrency[form.currencyCode].push(form);
          }
        }
        
        if(Object.keys(hashCurrency).length > 0){
          for(const currencyCode in hashCurrency){
            await this.$store.dispatch("settingTask/updateSettingTasks", hashCurrency[currencyCode]);
          }
        }

        this.loadingFinal = 1;
        this.settingTaskSelector = [];
        this.initData();
      }
      this.isLoading = false;
      this.isSendSettingTask = false;
      this.isLoadingDialog = false;
    }
  }
};
</script>

<style>
.nameProd {
  font-size: 1rem;
}

.v-data-table::v-deep th {
  color: #000;
  font-size: 1rem !important;
  text-align: center !important;
}

.v-data-table::v-deep td {
  font-size: 1rem !important;
  text-align: center !important;
  padding-right: 2rem !important;
}
</style>